import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/donut-chart/pages/CalculatorPage";

export const Route = createFileRoute("/donut-chart")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/donut-chart",
      title: m.donut_meta_title(),
      description: m.donut_meta_description(),
      toolName: m.donut_tool_name(),
      faqs: [
        { q: m.donut_faq_q1(), a: m.donut_faq_a1() },
        { q: m.donut_faq_q2(), a: m.donut_faq_a2() },
        { q: m.donut_faq_q3(), a: m.donut_faq_a3() },
        { q: m.donut_faq_q4(), a: m.donut_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
